import { useProperty, useTranslation } from '@eti/providers';
import { useRef, useState } from 'react';
import { Stack, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { useLocation } from 'react-router-dom';
import { price as priceUtils } from '@eti/utils';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { CABIN_UPGRADE } from '../../products';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getPriceLabel, getReadMoreLabel, getSingleChoiceProps, getUpsellProps, parseJsonProp } from '../../common/utils/productCardProps';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { validateCabinUpgradeAvailabilityTexts } from '../utils/utils';
import CabinUpgradeAvailabilityCard from './CabinUpgradeAvailabilityCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CABIN_UPGRADE;
const generalTexts = {
  additionalInformation: 'cabinUpgradeAdditionalInformation',
  ariaLabelText: 'ScreenReader.Notification.InfoStatusMessage.AriaLabel.Text',
  availabilityGeneralTexts: 'cabinUpgradeGeneralPurpose',
  destinationLabel: 'Searchform.Destination.Label',
  readMoreContent: 'cabinUpgradeReadMoreModalContent',
  description: 'cabinUpgradeAbstract',
  title: 'cabinUpgradeTitle',
  upSell: 'cabinUpgradeUpsell'
};
const cabinUpgradeContainer = css`
  display: grid;
  grid-area: 5 / 2 / 5 / 3;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
`;
const readMoreGrid = css`
  display: grid;

  .text {
    grid-area: 2 / 1 / 3 / 2;
  }

  .children {
    display: grid;
    grid-area: 1 / 1 / 2 / 2;
    margin-bottom: 16px;
    padding-inline: 16px;
  }
`;
const CabinUpgrade = _ref => {
  let {
    availabilityList,
    form,
    isPostBooking,
    order,
    productPosition
  } = _ref;
  const [isSelected, setSelected] = useState(null);
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const location = useLocation();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const translation = getTranslatedTexts(generalTexts, t);
  const rootElement = useRef(null);
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  const queryParams = new URLSearchParams(location.search);
  const isCabinUpgradeEnabled = queryParams.get('isCabinUpgradeEnabled') === 'true';
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product || !isPostBooking || !isCabinUpgradeEnabled) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const {
    ariaLabelText,
    additionalInformation,
    availabilityGeneralTexts,
    description,
    destinationLabel,
    readMoreContent,
    title,
    upSell
  } = translation;
  const onButtonChange = value => {
    const selectedValue = value === 'true';
    setSelected(selectedValue);
  };
  const availabilityTexts = parseJsonProp(availabilityGeneralTexts);
  const hasAvailabilityTexts = validateCabinUpgradeAvailabilityTexts(availabilityTexts);
  const shouldDisplayAvailability = availabilityList && availabilityList.length > 0 && hasAvailabilityTexts;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell);
  const buttonLabels = getSingleChoiceProps(t, p, nonDebugT);
  const productData = {
    additionalInformation,
    extraProps: {
      ...buttonLabels,
      onButtonChange
    },
    description,
    form,
    illustrationUrl,
    isSelected,
    isHighlighted: isUpsellHighlight,
    price: priceUtils.formatPrice(priceRaw),
    priceLabel: getPriceLabel(isSelected, t),
    priceRaw,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    readMoreButtonLabel: getReadMoreLabel(t),
    readMoreContent,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: productData,
    ref: rootElement,
    children: [shouldDisplayAvailability && /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      customGrid: readMoreGrid,
      children: /*#__PURE__*/_jsx(CabinUpgradeAvailabilityCard, {
        availabilityList: availabilityList,
        availabilityTexts: {
          ...availabilityTexts,
          ariaLabelText,
          destinationLabel
        }
      })
    }), isSelected && /*#__PURE__*/_jsxs(Stack, {
      className: cabinUpgradeContainer,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: "Select ticket type"
      }), /*#__PURE__*/_jsx(Text, {
        children: "Lorum ipsum la hej"
      })]
    })]
  });
};
export default CabinUpgrade;
//# sourceMappingURL=CabinUpgrade.js.map